// inbox-invalid-directive-rejection.ts — security F-02(c) (06k review).
//
// `readDirective` chỉ trả directive đúng `DirectiveSchema` (nguồn/kind lạ, JSON
// hỏng ⇒ không áp). Không để file đó nằm im lặng trong inbox: mỗi tick boundary
// journal `directive_rejected` (như approve/answer bị từ chối — R-08/H17), đánh
// `.processed` và báo người vận hành. Chạy TRƯỚC mọi drain.
import { randomUUID } from "node:crypto";
import {
  isDirectiveProcessed,
  listInboxDirectiveIds,
  markDirectiveProcessed,
  readInboxDirectiveRaw,
} from "./directive-inbox.js";
import type { MissionStore } from "./mission-store.js";
import { DirectiveSchema } from "./schemas/directive-schema.js";

export const INVALID_DIRECTIVE_REASON =
  "directive sai schema (nguồn/kind lạ hoặc JSON hỏng) — không áp";

export interface InvalidDirectiveRejectionInput {
  store: MissionStore;
  controlRoot: string;
  now?: () => Date;
  notify?: (message: string) => void;
}

function rawKind(raw: unknown): string {
  const kind = (raw as { kind?: unknown } | null)?.kind;
  return typeof kind === "string" && kind.length <= 40 ? kind : "unknown";
}

/** Trả số directive đã từ chối (0 khi inbox sạch). */
export async function rejectInvalidInboxDirectives(
  input: InvalidDirectiveRejectionInput,
): Promise<number> {
  let rejected = 0;
  for (const directiveId of await listInboxDirectiveIds(input.controlRoot)) {
    if (await isDirectiveProcessed(input.controlRoot, directiveId)) continue;
    const raw = await readInboxDirectiveRaw(input.controlRoot, directiveId);
    if (raw === undefined || DirectiveSchema.safeParse(raw).success) continue;
    await input.store.commit([
      {
        event_id: randomUUID(),
        delta: {
          kind: "directive_rejected" as const,
          directive_id: directiveId,
          directive_kind: rawKind(raw),
          reason: INVALID_DIRECTIVE_REASON,
        },
      },
    ]);
    await markDirectiveProcessed(input.controlRoot, directiveId, input.now ?? (() => new Date()));
    input.notify?.(`Directive ${directiveId} bị từ chối: ${INVALID_DIRECTIVE_REASON}`);
    rejected += 1;
  }
  return rejected;
}
